import * as _ from 'underscore';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField';
import SelectField from '../../../../_common/platform/ts/SelectField';
import { themeId, name, moduleName, themeFields } from '../config';
import { AlignmentType } from '../../../../_common/platform/ts/ConfigurationConstants';
import { WidthSelectorField } from '../../../../_common/platform/tsx/selectors/WidthSelector';

import {
    IValuesCollection,
    registerGroups,
    registerPreRender,
    registerSections,
    registerVars
} from '../../../../_common/platform/ts/appTheme';

function AlignmentSelectField(glob: IGlob, title: string, defaultValue: AlignmentType = 'left') {
    return new SelectField(glob, title, [], null, {
        values: [null, 'left', 'center', 'right'],
        display: ['default', 'left', 'center', 'right']
    });
}

const _init = [];

export function init(glob: IGlob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    widgetTheme(glob);

    // Register section, which will be displayed on the left of theme edit component
    registerSections([
        {
            id: themeId,
            name: name,
            parent: 'widget',

            themeType: name,
            visibility: ['application', 'workspace', moduleName]
        }
    ]);

    registerGroups([
        {
            id: themeFields.themeGroup_ColumnHeaders,
            name: 'Column Headers',
            section: themeId
        },
        {
            id: themeFields.themeGroup_RowHeaders,
            name: 'Row Headers',
            section: themeId
        },
        {
            id: themeFields.themeGroup_Rows,
            name: 'Rows',
            section: themeId
        },
        {
            id: themeFields.themeGroup_Columns,
            name: 'Columns',
            section: themeId
        }
    ]);

    registerVars([
        {
            id: themeFields.transposeColumnsToRows,
            param: new BooleanField(glob, 'Transpose Columns to Rows', [], false),
            section: themeId
        },
        {
            id: themeFields.columnHeaderFontColor,
            param: new ColorBoxField(
                glob,
                'Column Header Font Color',
                [],
                (theme: IValuesCollection) => {
                    return theme['on-secondary'];
                },
                { hideTransparency: true }
            ),
            section: themeId,
            deps: ['on-secondary'],
            group: themeFields.themeGroup_ColumnHeaders
        },
        {
            id: themeFields.columnHeaderBackgroundColor,
            param: new ColorBoxField(
                glob,
                'Column Header Background Color',
                [],
                (theme: IValuesCollection) => {
                    return theme['secondary-bg'];
                },
                { hideTransparency: false }
            ),
            section: themeId,
            deps: ['secondary-bg'],
            group: themeFields.themeGroup_ColumnHeaders
        },

        {
            id: themeFields.rowHeaderFontColor,
            param: new ColorBoxField(
                glob,
                'Row Header Font Color',
                [],
                (theme: IValuesCollection) => {
                    return theme['on-secondary'];
                },
                { hideTransparency: true }
            ),
            section: themeId,
            deps: ['on-secondary'],
            group: themeFields.themeGroup_RowHeaders
        },
        {
            id: themeFields.rowHeaderBackgroundColor,
            param: new ColorBoxField(
                glob,
                'Row Header Background Color',
                [],
                (theme: IValuesCollection) => {
                    return theme['secondary-bg'];
                },
                { hideTransparency: false }
            ),
            section: themeId,
            deps: ['secondary-bg'],
            group: themeFields.themeGroup_RowHeaders
        },
        {
            id: themeFields.rowHeaderWidth,
            param: new WidthSelectorField(glob, 'Width', {
                allowNull: true,
                hideOptionAuto: true
            }),
            section: themeId,
            group: themeFields.themeGroup_RowHeaders
        },
        {
            id: themeFields.rowHeaderAling,
            param: AlignmentSelectField(glob, 'Alignment'),
            section: themeId,
            group: themeFields.themeGroup_RowHeaders
        },

        {
            id: themeFields.rowsFontColor,
            param: new ColorBoxField(
                glob,
                'Rows Font Color',
                [],
                (theme: IValuesCollection) => {
                    return theme['on-secondary'];
                },
                { hideTransparency: true }
            ),
            section: themeId,
            deps: ['on-secondary'],
            group: themeFields.themeGroup_Rows
        },
        {
            id: themeFields.rowsBackgroundColor,
            param: new ColorBoxField(
                glob,
                'Rows Background Color',
                [],
                (theme: IValuesCollection) => {
                    return theme['body-bg'];
                },
                { hideTransparency: false }
            ),
            section: themeId,
            deps: ['body-bg'],
            group: themeFields.themeGroup_Rows
        },
        {
            id: themeFields.columnsWidth,
            param: new WidthSelectorField(glob, 'Width', {
                allowNull: true,
                hideOptionAuto: true
            }),
            section: themeId,
            group: themeFields.themeGroup_Rows
        },

        {
            id: themeFields.columnsAlign,
            param: AlignmentSelectField(glob, 'Alignment'),
            section: themeId,
            group: themeFields.themeGroup_Columns
        }
    ]);

    registerPreRender(function (input) {
        const vars = {};

        return _.extend(input, vars);
    });

    _init.push(glob);
}
